<nz-header class="global-primary-header">
  <div nz-row class="global-primary-header-wrapper">
    <div
      class="logo-holder"
      nz-col
      [nzSpan]="24"
      [nzSm]="7"
      [nzMd]="7"
      [nzLg]="7"
      [nzXl]="7"
      [nzXXl]="6"
    >
      <span class="va-logo">
        <a routerLink="/home"
          ><img
            [src]="assets + '/VisibleAlpha_horizontal_spg_pos_rgb_v4.svg'"
            alt="Visible Alpha now a part of S&P Global Market Intelligence"
        /></a>
      </span>
      <span class="menu-wrapper">
        <app-global-menu></app-global-menu>
      </span>
      <span
        class="imitateMsg"
        (click)="stopImitation()"
        *ngIf="imitationBy && imitationBy != ''"
      >
        <va-icon name="close" class="fa-lg"></va-icon> Under Imitation by
        {{ imitationBy }}
      </span>
    </div>
    <div
      nz-col
      [nzSpan]="24"
      [nzSm]="9"
      [nzMd]="9"
      [nzLg]="9"
      [nzXl]="9"
      [nzXXl]="12"
      class="search-bar-wrapper"
    >
      <app-global-search
        [recentlyVisitedCompanies]="recentlyVisitedCompanies"
      ></app-global-search>
      <app-notification-renderer></app-notification-renderer>
    </div>
    <div
      nz-col
      [nzSpan]="24"
      [nzSm]="8"
      [nzMd]="8"
      [nzLg]="8"
      [nzXl]="8"
      [nzXXl]="6"
      class="header-action-icon"
    >
      <div nz-row nzType="flex" nzJustify="end" nzGutter="1">
        <!-- dont change id of pendoHelpIcon -->
        <span class="help-icon" id="pendoHelpIcon">
          <va-icon name="question-circle" class="fa-lg"></va-icon>
          <span class="help-text">Help</span>
        </span>
        <app-global-sso-menu></app-global-sso-menu>
        <span nzType="default" class="feedback-btn" (click)="onClickFeedback()">
          <va-icon name="comment" class="fa-lg"></va-icon>
          Feedback
        </span>
        <span nzType="default" class="feedback-btn" (click)="onClickLiveChat()">
          <va-icon name="comment" class="fa-lg"></va-icon>
          Live Chat
        </span>
        <span class="notif-section">
          <app-global-notification></app-global-notification>
          <app-global-user-menu></app-global-user-menu>
        </span>
      </div>
    </div>
  </div>
</nz-header>
<nz-modal
  [(nzVisible)]="showDeprModal"
  nzTitle="Internet Explorer is no longer supported."
  (nzOnOk)="IEUnderstand()"
  nzWidth="700px"
  nzOkText="Ok - I understand using IE may result in long loading times or glitches"
  [nzCancelText]="null"
  [nzCloseIcon]="closeTemplate"
>
  <div class="textSection">
    <p>We have detected that you are using Internet Explorer (IE).</p>
    <p>
      To get the best experience using our site, please upgrade to a newer
      browser. We recommend Google Chrome or Microsoft Edge, which is included
      with Windows 10.
    </p>
    <p>
      Outdated browsers (like IE) can expose your computer to security risks and
      can cause problems for Visible Alpha users like slower load times or
      glitches.
    </p>
    <p>
      Please reach out to our support team if you have any questions -
      <a href="mailto:support@visiblealpha.com"
        >support&#64;visiblealpha.com.</a
      >
      <span class="depr-details" *ngIf="!showDeprDetails">
        For more information on why we made these changes,
        <a (click)="showDeprDetails = true">click here.</a></span
      >
    </p>
    <p *ngIf="showDeprDetails">
      Starting in January 2020, Microsoft ended support for Windows 7. This
      change means any supported version of Windows must include Microsoft Edge,
      the replacement for Internet Explorer. To keep up with these changes,
      Visible Alpha no longer plans to support Internet Explorer.
    </p>
  </div>
</nz-modal>
<ng-template #closeTemplate>
  <div></div>
</ng-template>
